export default ({ dispatch }) =>
  (next) =>
  (action) => {
    if (Array.isArray(action)) {
      return Promise.all(action.map(dispatch));
    }
    return next(action);
  };
